import { render } from "./oap-make-the-switch-top-nav.vue?vue&type=template&id=6a9e1375"
import script from "./oap-make-the-switch-top-nav.vue?vue&type=script&lang=js"
export * from "./oap-make-the-switch-top-nav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__